<template>
  <div class="col-12 connections py-4 mb-4">
    <div class="card">
      <div class="card-header">
        <h5 class="card-title mb-0">Учредители</h5>
      </div>
      <div class="card-body">
        <template v-if="founders?.length">
          <!-- <div class="d-flex justify-content-between">
            <div class="filter-container d-flex align-items-center my-4">
              <label for="type-filter">Период</label>
              <input
                type="date"
                id="period-filter"
                class="form-select w-auto ms-4"
                v-model="selectedPeriod"
                @change="filterOrganizations"
              />
            </div>
          </div> -->
          <div v-if="filteredFounders.length">
            <div v-for="(founder, index) in filteredFounders" :key="index" class="connections-list">
              <div class="connections-list__header">
                <h4>Актуальные</h4>
              </div>
              <div class="connections-list__body d-flex justify-content-between col-10">
                <p class="value">{{ founder.fio || founder.name }}</p>
                <span class="label">Дата</span>
                <p class="value">{{ formatDate(founder.record_date) }}</p>
                <span class="label">Доля</span>
                <p class="value">{{ Number(founder.fraction?.percent) }}%</p>
                <span class="label">ИНН</span>
                <p class="value">{{ founder.inn }}</p>
              </div>
            </div>
          </div>
        </template>
        <template v-else><p class="text-center">Нет данных</p> </template>
      </div>
    </div>
  </div>
</template>
<script>
  import { computed, defineComponent } from 'vue';
  import moment from 'moment';

  export default defineComponent({
    name: 'Founders',
    props: {
      founders: Array,
    },
    setup(props) {
      const filteredFounders = computed(() => props.founders || []);

      const formatDate = (date) => {
        return moment(date).format('DD.MM.YYYY');
      };

      return {
        filteredFounders,
        formatDate,
      };
    },
  });
</script>
